module.exports = __webpack_public_path__ + "dimer/static/img/t$eImg5.da61dd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t$eImg5.jpg
// module id = pNJD
// module chunks = 0